// src/utils/statistics.ts
function max(x) {
  if (x.length === 0) {
    throw new Error("max requires at least one data point");
  }
  let value = x[0];
  for (let i = 1; i < x.length; i++) {
    if (x[i] > value) {
      value = x[i];
    }
  }
  return value;
}
function min(x) {
  if (x.length === 0) {
    throw new Error("min requires at least one data point");
  }
  let value = x[0];
  for (let i = 1; i < x.length; i++) {
    if (x[i] < value) {
      value = x[i];
    }
  }
  return value;
}
function sum(x) {
  if (x.length === 0) {
    return 0;
  }
  let sumNum = x[0];
  let correction = 0;
  let transition;
  for (let i = 1; i < x.length; i++) {
    transition = sumNum + x[i] * 1;
    if (Math.abs(sumNum) >= Math.abs(x[i])) {
      correction += sumNum - transition + x[i];
    } else {
      correction += x[i] - transition + sumNum;
    }
    sumNum = transition;
  }
  return sumNum + correction * 1;
}
function mean(x) {
  if (x.length === 0) {
    throw new Error("mean requires at least one data point");
  }
  return sum(x) / x.length;
}
var statMap = {
  min,
  max,
  mean,
  sum
};
export {
  max,
  mean,
  min,
  statMap,
  sum
};
